import React from "react";
import SystemGraphs from "./SystemGraphs";

const PlumbDitch = () => {
  const defaultParameter = 67;

  const pageTitle = "Plumb Ditch";

  const endpoints = [
    { label: "15 Minutes", value: "display011-data15-min" },
    { label: "Daily", value: "display011-data-daily" },
  ];

  const parametersEndpoint = "display011-lookup-parameter";

  const mapEndpoint = "display011-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
        displayIndex="011"
      />
    </>
  );
};

export default PlumbDitch;
